export const TEXTS = {
  VALIDATION: {
    TITLE: 'Решите пример, чтобы подтвердить\n отправку email',
    DEFAULT_WARNING: 'Записаться на эфир можно только\nсо взрослым',
  },
  COMPLETED: {
    TITLE: 'Отлично! Вы записаны на эфир',
    TEXT: 'Перед началом пришлем ссылку на занятие на ваш email',
  },
  AFTER_BUY_COMPLETED: {
    TITLE: 'Отлично!',
    TEXT: 'Материалы отправлены на ваш email',
  },
};
